import React from 'react';
import PropTypes from 'prop-types';
import ColorPicker from 'common/components/color-picker';
import Modal from 'common/components/modal';
import ModalBody from 'common/components/modal-body';
import ModalFooter from 'common/components/modal-footer';
import ModalHeader from 'common/components/modal-header';
import Select from 'common/components/select';
import {t} from 'common/utils/translation-util';
import './index.scss';

export default class StoryboardThemeModal extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func,
    data: PropTypes.object.isRequired,
    editTheme: PropTypes.func,
    enums: PropTypes.object.isRequired,
    isOpen: PropTypes.bool,
  };

  static defaultProps = {
    closeModal: null,
    editTheme: () => {},
    isOpen: false,
  };

  constructor(props) {
    super();
    this.handleCancel = this.handleCancel.bind(this);
    this.handleBackgroundColorsChange =
      this.handleBackgroundColorsChange.bind(this);
    this.handleLogoBarColorsChange = this.handleLogoBarColorsChange.bind(this);
    this.handleLogoBarPositionChange =
      this.handleLogoBarPositionChange.bind(this);
    this.handleNavColorsChange = this.handleNavColorsChange.bind(this);
    this.handleNavPositionChange = this.handleNavPositionChange.bind(this);
    this.handleSave = this.handleSave.bind(this);

    const {theme} = props.data.configuration;
    this.state = {
      backgroundColors: theme.backgroundColors,
      logoBarColors: theme.logoBarColors,
      logoBarPosition: theme.logoBarPosition,
      navColors: theme.navColors,
      navPosition: theme.navPosition,
    };
  }

  getLogoBarPositionOptions(enums) {
    const {LogoBarPositionEnum} = enums;
    return [
      {
        label: LogoBarPositionEnum.TOP.displayName,
        value: LogoBarPositionEnum.TOP.id,
      },
      {
        label: LogoBarPositionEnum.BOTTOM.displayName,
        value: LogoBarPositionEnum.BOTTOM.id,
      },
    ];
  }

  getNavPositionOptions(enums) {
    const {NavPositionEnum} = enums;
    return Object.keys(NavPositionEnum)
      .sort()
      .map((position) => ({
        label: NavPositionEnum[position].displayName,
        value: NavPositionEnum[position].id,
      }));
  }

  render() {
    const {superpartnerFooterLogo} = this.props.data.configuration;
    return (
      <Modal className={'StoryboardThemeModal'} isOpen={this.props.isOpen}>
        <ModalHeader>{t('Edit theme')}</ModalHeader>

        <ModalBody>
          <h4>{t('Background color')}</h4>
          <ColorPicker
            color={this.state.backgroundColors[0]}
            handleChange={this.handleBackgroundColorsChange}
          />

          <h4>{t('Navigation bar color')}</h4>
          <ColorPicker
            color={this.state.navColors[0]}
            handleChange={this.handleNavColorsChange}
          />

          {superpartnerFooterLogo ? null : <h4>{t('Logo bar color')}</h4>}
          {superpartnerFooterLogo ? null : (
            <ColorPicker
              color={this.state.logoBarColors[0]}
              handleChange={this.handleLogoBarColorsChange}
            />
          )}

          <h4>{t('Navigation bar position')}</h4>
          <Select
            onChange={this.handleNavPositionChange}
            options={this.getNavPositionOptions(this.props.enums)}
            value={this.state.navPosition}
          />

          <h4>{t('Logo bar position')}</h4>
          <Select
            onChange={this.handleLogoBarPositionChange}
            options={this.getLogoBarPositionOptions(this.props.enums)}
            value={this.state.logoBarPosition}
          />
        </ModalBody>

        <ModalFooter onCancel={this.handleCancel} onSave={this.handleSave} />
      </Modal>
    );
  }

  handleBackgroundColorsChange(color) {
    this.setState({
      backgroundColors: [color],
    });
  }

  handleCancel() {
    this.props.closeModal();
  }

  handleLogoBarColorsChange(color) {
    this.setState({
      logoBarColors: [color],
    });
  }

  handleLogoBarPositionChange(logoBarPosition) {
    this.setState({
      logoBarPosition,
    });
  }

  handleNavColorsChange(color) {
    this.setState({
      navColors: [color],
    });
  }

  handleNavPositionChange(navPosition) {
    this.setState({
      navPosition,
    });
  }

  handleSave() {
    this.props.editTheme({
      ...this.state,
    });
    this.props.closeModal();
  }
}
